import api from '../../api'

export type JobScheduleEvent = {
  id: number
  startUtc: string
  endUtc: string
  allDay: boolean
  crewForemanEmail: string | null
  dailyManhours: number | null
  frozen: boolean
  workAreaNames: string[]
  schedulingNotes: string | null
}

export const getJobScheduleEvents = async (jobId: number): Promise<JobScheduleEvent[]> => {
  return (await api.get(`/web/scheduling/events/job/${jobId}`)).data
}
